import type { SortRequest } from '@/types/Api'
import type { UUID } from '@/types/Id'
import type { Status } from '@/types/task/Task'

interface OrganizationTasksQueryKeyArgs {
  orgId: UUID | ''
}

interface PursuitTasksQueryKeyArgs {
  pursuitId: UUID | ''
}

interface UserTasksQueryKeyArgs {
  orgId: UUID | ''
  status: Status[]
  limit: number
  offset: number
  order_by: string
  sort: SortRequest['sort']
}

export const tasksQueryKeys = {
  all: () => ['tasks'] as const,
  organization: (keyArgs: OrganizationTasksQueryKeyArgs) =>
    ['tasks', 'organization', keyArgs.orgId] as const,
  pursuit: (keyArgs: PursuitTasksQueryKeyArgs) =>
    ['tasks', 'pursuit', keyArgs.pursuitId] as const,
  // prefix covering every user-assigned variant (home calendar, action
  // items, /tasks page) — mutations invalidate this so those views refetch
  userAll: () => ['tasks', 'user'] as const,
  user: (keyArgs: UserTasksQueryKeyArgs) =>
    [
      'tasks',
      'user',
      keyArgs.orgId,
      ...keyArgs.status.sort(),
      keyArgs.limit,
      keyArgs.offset,
      keyArgs.order_by,
      keyArgs.sort,
    ] as const,
}
